export default {
  CREATE: `Create a new department`,
  DELETE_BUTTON: {
    TITLE: `Delete the department`,
    SUMMARY: `Are you sure you want to delete this department?`,
    PRIMARY_ACTION: `Delete the department`
  },
  LIST: {
    TITLE: `Department list`,
    SUMMARY: ``
  },
  TRANSFER_PHONE: `Transfer phone (for attendance calls)`,
  CSV_EXPORT_NAME: `departments_export_{{date}}`,
  form: {
    CREATE: {
      TITLE: `Creating a department`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Editing a department`,
      SUMMARY: ``
    },
    NAMEFR: {
      LABEL: `Department french name`,
      DESCRIPTION: `This name should help you quickly identify the department.`,
      PLACEHOLDER: `Enter a french name for the department`
    },
    NAMEEN: {
      LABEL: `Department english name`,
      DESCRIPTION: `This name should help you quickly identify the department.`,
      PLACEHOLDER: `Enter an english name for the department`
    },
    CODE: {
      LABEL: `Import code`,
      DESCRIPTION: `This will be used in the import tools to assign departments to other resources.`,
      PLACEHOLDER: `Enter the import code`
    },
    TRANSFERPHONE: {
      PHONENUMBER: {
        LABEL: `Phone number`,
        DESCRIPTION: `This phone number allows transferring of attendance phone calls to a unique number per department.`,
        PLACEHOLDER: `Enter the phone number`
      },
      EXTENSION: {
        LABEL: `Extension`,
        DESCRIPTION: ``,
        PLACEHOLDER: `Enter the phone number extension`
      }
    },
    ATTENDANCE_CALL_TRANSFER: `Attendance call transfer`,
    NAME_EN_REQUIRED: `Department's name is mandatory.`,
    NAME_FR_REQUIRED: `Department's name is mandatory.`
  }
}
